import ContentTrivia from "./ContentTrivia";
export default ContentTrivia;
